import { itwApi } from '@application/api/middlewares/api';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
const initialState = {
    systems: null,
    systemEditMode: null,
    selectedSystem: null,
    loading: false,
    error: null,
    assetId: '',
    pageNumber: 1,
    pageSize: 10,
    isSystemUpdated: false
};
// Fetch systems
export const fetchSystems = createAsyncThunk('systemDetail/fetchSystems', async (assetId, { getState, rejectWithValue }) => {
    const state = getState();
    const { pageNumber, pageSize } = state.systemDetail;
    try {
        const response = await itwApi.get('System/get-system-detail', { params: { AssetId: assetId, PageNumber: pageNumber, PageSize: pageSize } });
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch system details');
    }
});
// Fetch system by ID
export const fetchSystemById = createAsyncThunk('systemDetail/getSystemById', async (systemId, { rejectWithValue }) => {
    try {
        const response = await itwApi.get(`/System/${systemId}`);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch system details');
    }
});
// Delete system by ID
export const DeleteSystem = createAsyncThunk('systemDetail/deleteSystem', async (systemId, { rejectWithValue }) => {
    try {
        const response = await itwApi.delete(`/System/${systemId}`);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to delete system details');
    }
});
// Create system
export const createSystem = createAsyncThunk('systemDetail/createSystem', async (systemDetailData, { rejectWithValue }) => {
    try {
        const response = await itwApi.post('/System', systemDetailData);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to create system');
    }
});
// Update system by ID
export const updateSystem = createAsyncThunk('systemDetail/updateSystem', async (data, { rejectWithValue }) => {
    try {
        const response = await itwApi.put(`/System`, data);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to Update system details');
    }
});
export const systemSlice = createSlice({
    name: 'systemDetail',
    initialState,
    reducers: {
        clearSystems: (state) => {
            state.systems = null;
        },
        clearSelectedSystem: (state) => {
            state.selectedSystem = null;
        },
        setIsSystemUpdated: (state) => {
            state.isSystemUpdated = !state.isSystemUpdated;
        },
        setSystemEditMode: (state, action) => {
            state.systemEditMode = action.payload;
        },
        resetSystemEditMode: (state) => {
            state.systemEditMode = {};
        },
        setAssetId: (state, action) => {
            state.assetId = action.payload;
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSystems.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchSystems.fulfilled, (state, action) => {
            state.loading = false;
            state.systems = action.payload;
        })
            .addCase(fetchSystems.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'An error occurred';
        })
            .addCase(fetchSystemById.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchSystemById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedSystem = action.payload;
        })
            .addCase(DeleteSystem.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(DeleteSystem.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.data) {
                state.selectedSystem = null;
            }
            else {
                state.error = 'Failed to delete system';
            }
        })
            .addCase(DeleteSystem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'An error occurred';
        })
            .addCase(createSystem.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(createSystem.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedSystem = action.payload;
        })
            .addCase(createSystem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'An error occurred';
        })
            .addCase(updateSystem.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
            .addCase(updateSystem.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedSystem = null;
        })
            .addCase(updateSystem.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || 'An error occurred';
        });
    }
});
export const { clearSystems, clearSelectedSystem, setAssetId, setPageNumber, setPageSize, setSystemEditMode, setIsSystemUpdated, resetSystemEditMode } = systemSlice.actions;
export default systemSlice.reducer;
